export const TaskTypeSelector = ({ taskTypeFilter, onTaskTypeChange }) => {
    const taskTypes = [
        { value: 'All', label: 'All', icon: 'fas fa-layer-group' },
        { value: 'Inspection', label: 'Inspection', icon: 'fas fa-search' },
        { value: 'Maintenance', label: 'Maintenance', icon: 'fas fa-wrench' }
    ];

    const selectedType = taskTypes.find(type => type.value === taskTypeFilter) || taskTypes[0];

    return (
        <div className="dropdown-toggle">
            <div style={{ cursor: "pointer" }} data-bs-toggle="dropdown" className="text-decoration-none text-dark fs-5">
                <i className={`${selectedType.icon} fa-fw text-dark text-opacity-50 me-1`}></i> 
                {selectedType.label} 
                <b className="ms-5px caret"></b>
            </div>

            <div className="dropdown-menu dropdown-menu-start">
                {taskTypes.map(type => (
                    <div 
                        onClick={() => onTaskTypeChange(type.value)} 
                        style={{ cursor: "pointer" }} 
                        key={type.value} 
                        className="dropdown-item fs-5"
                    >
                        <i className={`${type.icon} fa-fw fa-lg text-gray-500 me-1`}></i>
                        {type.label}
                    </div>
                ))}
            </div>
        </div>
    );
};